import axios from 'axios'
import { globalConfig } from '../config/config';

export const instance = axios.create({
  baseURL: globalConfig.apiBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const setToken = token => {
  instance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export const API_PATHS = {
  mainPath: `/security`,
  datahubPath: `/security/api-proxy-service`,
  diagnosticPath: `/diagnostics`,
}
